<script lang="ts">
  interface Properties {
    onSwap: () => void;
    disabled?: boolean;
  }

  const { onSwap, disabled = false }: Properties = $props();
</script>

<!-- One-shot swap-endpoints button. Compact so it can sit between two inputs
     without dominating the layout. -->
<button
  type="button"
  class="swap-btn"
  aria-label="Swap origin and destination"
  {disabled}
  onclick={onSwap}
>
  ↕
</button>

<style>
  .swap-btn {
    background: none;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    color: var(--color-fg-muted);
    cursor: pointer;
    padding: 2px 8px;
    margin: 0 0 4px;
    font-size: var(--font-size-md);
    line-height: 1;
  }

  .swap-btn:hover:not(:disabled) {
    border-color: var(--color-primary);
    color: var(--color-primary);
  }

  .swap-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
